import { render, staticRenderFns } from "./AuditHelpTab.vue?vue&type=template&id=087b0426&"
import script from "./AuditHelpTab.vue?vue&type=script&lang=js&"
export * from "./AuditHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports